import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { TransactionData } from '../interface/transazioni';

interface TransactionTableProps {
  data: TransactionData;
}

export const TransactionTable = ({ data }: TransactionTableProps) => {
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Riepilogo Donazioni
      </Typography>

      {data.donazioni.map((dayData) => (
        <Box key={dayData.date} mb={4}>
          <Typography variant="subtitle1" fontWeight="bold" mb={2}>
            Data: {new Date(dayData.date).toLocaleDateString('it-IT')}
          </Typography>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Prodotto</TableCell>
                  <TableCell align="right">Contanti</TableCell>
                  <TableCell align="right">POS</TableCell>
                  <TableCell align="right">PayByLink</TableCell>
                  <TableCell align="right">Totale Quantità</TableCell>
                  <TableCell align="right">Totale Importo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dayData.prodotti.map((prodotto) => (
                  <TableRow key={prodotto.id_prodotto}>
                    <TableCell>{prodotto.nome}</TableCell>
                    <TableCell align="right">
                      {prodotto.dettaglio_donazioni.find((d) => d.metodo_pagamento === 'contanti')?.quantita || 0}
                      {' (€'}
                      {prodotto.dettaglio_donazioni
                        .find((d) => d.metodo_pagamento === 'contanti')
                        ?.importo.toFixed(2) || '0.00'}
                      {')'}
                    </TableCell>
                    <TableCell align="right">
                      {prodotto.dettaglio_donazioni.find((d) => d.metodo_pagamento === 'pos')?.quantita || 0}
                      {' (€'}
                      {prodotto.dettaglio_donazioni.find((d) => d.metodo_pagamento === 'pos')?.importo.toFixed(2) ||
                        '0.00'}
                      {')'}
                    </TableCell>
                    <TableCell align="right">
                      {prodotto.dettaglio_donazioni.find((d) => d.metodo_pagamento === 'paybylink')?.quantita || 0}
                      {' (€'}
                      {prodotto.dettaglio_donazioni
                        .find((d) => d.metodo_pagamento === 'paybylink')
                        ?.importo.toFixed(2) || '0.00'}
                      {')'}
                    </TableCell>
                    <TableCell align="right">{prodotto.totale.quantita}</TableCell>
                    <TableCell align="right">€{prodotto.totale.importo.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell>
                    <strong>Totali del Giorno</strong>
                  </TableCell>
                  <TableCell align="right">
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'contanti')?.quantita || 0}
                    {' (€'}
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'contanti')?.importo.toFixed(2) ||
                      '0.00'}
                    {')'}
                  </TableCell>
                  <TableCell align="right">
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'pos')?.quantita || 0}
                    {' (€'}
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'pos')?.importo.toFixed(2) ||
                      '0.00'}
                    {')'}
                  </TableCell>
                  <TableCell align="right">
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'paybylink')?.quantita || 0}
                    {' (€'}
                    {dayData.totali_per_pagamento.find((t) => t.metodo_pagamento === 'paybylink')?.importo.toFixed(2) ||
                      '0.00'}
                    {')'}
                  </TableCell>
                  <TableCell align="right">
                    {dayData.totali_per_pagamento.reduce((acc, curr) => acc + curr.quantita, 0)}
                  </TableCell>
                  <TableCell align="right">
                    €{dayData.totali_per_pagamento.reduce((acc, curr) => acc + curr.importo, 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Totale Generale
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Prodotto</TableCell>
                <TableCell align="right">Quantità Totale</TableCell>
                <TableCell align="right">Importo Totale</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.totale_generale.map((totale) => (
                <TableRow key={totale.id_prodotto}>
                  <TableCell>{totale.nome}</TableCell>
                  <TableCell align="right">{totale.quantita}</TableCell>
                  <TableCell align="right">€{totale.importo.toFixed(2)}</TableCell>
                </TableRow>
              ))}
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell>
                  <strong>Totale Complessivo</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{data.totale_generale.reduce((acc, curr) => acc + curr.quantita, 0)}</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>€{data.totale_generale.reduce((acc, curr) => acc + curr.importo, 0).toFixed(2)}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};
